<div
	class="d-flex justify-content-between flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-primary text-white border-bottom box-shadow"
	routerLink=""
>
	<div class="d-flex align-items-center">
		<img class="logo" src="../../assets/images/logo.svg" />
		<!-- <h5 class="my-0 mr-md-auto font-weight-normal text-white">UniPd - Poc</h5> -->
	</div>
	<!-- <nav class="my-2 my-md-0 mr-md-3">
    <a class="p-2 text-dark" routerLink="/">Ask</a>
    <a class="p-2 text-dark" routerLink="/admin">Digest</a>
  </nav> -->
	{{user.email}}
</div>
